export default __webpack_public_path__ + "static/media/08_GoldAndBlack.dd295627.png";